const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2250 2250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1125,325.495l692.391,399.753l0,799.504l-692.391,399.753l-692.391,-399.753l-0,-799.504l692.391,-399.753Zm0,42.926l-655.216,378.29l-0,756.578l655.216,378.29l655.216,-378.29l0,-756.578l-655.216,-378.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1110.35,512.483l530.455,306.259l0,612.516l-530.455,306.259l-530.455,-306.259l0,-612.516l530.455,-306.259Zm-35.731,204.919l-0,101.772l-76.33,-0c-69.205,-0 -127.215,58.01 -127.215,127.215l-0,50.887c-0,69.205 44.78,126.197 110.932,143.499l260.537,67.17c14.248,4.07 34.603,29.514 34.603,44.779l-0,50.887c-0,14.248 -11.195,25.443 -25.443,25.443l-254.431,-0c-12.213,-0 -21.373,-4.071 -25.443,-6.107l-0,-95.666l-101.773,0l0,101.773c0,34.602 20.355,64.116 44.78,79.382c23.408,16.284 52.922,22.39 82.436,22.39l76.329,0l-0,101.772l101.772,0l0,-101.772l76.33,0c70.223,0 127.215,-56.992 127.215,-127.215l0,-50.887c0,-69.205 -44.78,-126.197 -110.932,-143.499l-260.537,-67.17c-14.248,-4.07 -34.603,-29.514 -34.603,-44.779l0,-50.887c0,-14.248 11.195,-25.443 25.443,-25.443l254.431,0c11.195,0 21.373,4.071 25.443,6.107l0,95.666l101.773,-0l-0,-101.773c-0,-34.602 -20.355,-64.116 -44.78,-79.382c-23.408,-16.284 -52.922,-22.39 -82.436,-22.39l-76.329,-0l0,-101.772l-101.772,-0Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSymbol);
export default __webpack_public_path__ + "static/media/dollar-symbol.242e7af1831b39f17ba5ebf464c1417c.svg";
export { ForwardRef as ReactComponent };